const magazineArchive = [
	{
		id: "3-2025",
		issueNumber: "3/2025",
		coverImage: "https://image.isu.pub/250522101252-c8d36e993155781b1d0d7eebcb082c49/jpg/page_1_thumb_large.jpg",
		year: 2025,
		month: "mai",
	},
	{
		id: "_bv2025-1",
		issueNumber: "1/2025",
		coverImage: "https://image.isu.pub/250318114040-4837d890232a179283f2efb01030b19f/jpg/page_1_thumb_large.jpg",
		year: 2025,
		month: "mars",
	},
	{
		id: "bv2024-6_presspad",
		issueNumber: "6/2024",
		coverImage: "https://image.isu.pub/241017184853-a0f44dbc60c7752e1ffde9dd46f6d5d9/jpg/page_1_thumb_large.jpg",
		year: 2024,
		month: "oktober",
	},
	{
		id: "bv2024-3_presspad",
		issueNumber: "3/2024",
		coverImage: "https://image.isu.pub/240522143154-5e418278889bab769ec4c7c6c021b68d/jpg/page_1_thumb_large.jpg",
		year: 2024,
		month: "juni",
	},
	{
		id: "bv2024-1_presspad",
		issueNumber: "1/2024",
		coverImage: "https://image.isu.pub/240226143029-dd72e29489a3a5d2f9cd00bf226f25ed/jpg/page_1_thumb_large.jpg",
		year: 2024,
		month: "mars",
	},
	{
		id: "bv2023-6_presspad",
		issueNumber: "6/2023",
		coverImage: "https://image.isu.pub/230815202352-6a7bb3537cff25be96f2426acce7972a/jpg/page_1_thumb_large.jpg",
		year: 2023,
		month: "september",
	},
	{
		id: "bv2023-4_presspad",
		issueNumber: "4/2023",
		coverImage: "https://image.isu.pub/230802100609-a82ccbc02385c1f1bfb0ced22e95fb9a/jpg/page_1_thumb_large.jpg",
		year: 2023,
		month: "juni",
	},
	{
		id: "bv2023-2_presspad",
		issueNumber: "2/2023",
		coverImage: "https://image.isu.pub/230802101436-29031524827cb5bb10cf9e643f9070ec/jpg/page_1_thumb_large.jpg",
		year: 2023,
		month: "mars",
	},
	{
		id: "bv2022-6_presspad",
		issueNumber: "6/2022",
		coverImage: "https://image.isu.pub/230802102208-17e0384ffa0ec997e9fa64e520c5971d/jpg/page_1_thumb_large.jpg",
		year: 2022,
		month: "september",
	},
	{
		id: "bv2022-4_presspad",
		issueNumber: "4/2022",
		coverImage: "https://image.isu.pub/230802102531-f22f3ce232ce4138b8ed72169e236c74/jpg/page_1_thumb_large.jpg",
		year: 2022,
		month: "juni",
	},
	{
		id: "bv2022-2_presspad",
		issueNumber: "2/2022",
		coverImage: "https://image.isu.pub/230802102912-da3859126f4fdec1a0c52acfff94d01b/jpg/page_1_thumb_large.jpg",
		year: 2022,
		month: "mars",
	},
];

export default magazineArchive;